"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networkPanelType = void 0;
exports.networkPanelType = { "HEALTH": { "name": { "code": "HEALTH", "localize": { "en": "Health centers", "th": "สถานบริการสุขภาพ" } } }, "GARAGE": { "name": { "code": "GARAGE", "localize": { "en": "Garage", "th": "อู่และศูนย์ซ่อมรถ" } } } };
